import {Component, inject, OnInit} from '@angular/core';
import {FeedbackDto, FeedbackService, FeedbackSubject} from '../../services/feedback.service';
import {BehaviorSubject, take} from 'rxjs';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CookieStorageService} from '../../services/cookie-storage.service';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {CheckboxModule} from 'primeng/checkbox';
import {ButtonDirective} from 'primeng/button';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {AsyncPipe} from '@angular/common';
import {SkeletonModule} from 'primeng/skeleton';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { InputMaskModule } from 'primeng/inputmask';

@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    CheckboxModule,
    ButtonDirective,
    InputTextareaModule,
    AsyncPipe,
    SkeletonModule,
    InputMaskModule
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackComponent implements OnInit {
  _feedback = inject(FeedbackService);
  _cookie = inject(CookieStorageService)
  _dialog = inject(DynamicDialogConfig);

  feedbackForm = new FormGroup({
    subjectId: new FormControl<number | null>(this._dialog.data || null, Validators.required),

    email: new FormControl<string | null>(null, [Validators.required, Validators.email]),
    phone: new FormControl<string | null>(null, Validators.required),
    fullName: new FormControl<string | null>(null, Validators.required),

    body: new FormControl<string | null>(null, Validators.required),

    userKey: new FormControl<string>(this._cookie.get('userSessionId')),

    agreeWithPersonalDataHandling: new FormControl<boolean>(false, Validators.requiredTrue)
  })

  private loading = new BehaviorSubject<boolean>(true)
  loading$ = this.loading.asObservable();

  private loadingSend = new BehaviorSubject<boolean>(true)
  loadingSend$ = this.loading.asObservable();

  subjects: {value: number, display: string}[] = [];

  ngOnInit() {
    this.getFeedbackSubjects();
  }

  getFeedbackSubjects() {
    this.loading.next(true);
    this._feedback.fetchFeedbackSubjects()
      .subscribe(subjects => {
        this.subjects = subjects;
        this.loading.next(false)
      })
  }

  sendFeedback() {
    this.feedbackForm.markAllAsTouched();
    const body: FeedbackDto = {
      ...this.feedbackForm.getRawValue(),
      phone: `+7${this.feedbackForm.getRawValue().phone}`,
      saveComplaint: false,
      referrerURL: window.location.href,
      complaintSubject: null,
    }
    if (this.feedbackForm.invalid) return;
    this.loadingSend.next(true);
    this._feedback.sendFeedback(body)
      .pipe(
        take(1)
      )
      .subscribe(() => {
        console.log('Отправили')
      })

  }


}
